import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { SugarService } from '../../model/sugar.service';
import { UrlService } from '../../model/url.service';
import { UniversalRendererHelper } from '../../shared/platform/universal-renderer.helper';
import { Utils } from '../../shared/utils.class';
import { AutoUnsubscribe } from '../../decorators/autounsubscribe.decorator';
var DropdownSortComponent = /** @class */ (function () {
    function DropdownSortComponent(_sugarService, _rendererHelper, urlService) {
        this._sugarService = _sugarService;
        this._rendererHelper = _rendererHelper;
        this.urlService = urlService;
        this.sortBy = {};
        this.currentValue = '';
        this.collection = '';
        this.title = '';
        this.menuVersion = 'dropdown';
        this.eventChange = new EventEmitter();
        this.closeTimeout = null;
        this.menuID = Utils.randomString();
    }
    DropdownSortComponent.prototype.ngOnInit = function () {
        this.sortBy = this._sugarService.getAvailableSorting(this.collection);
        if (!this.options) {
            this.options = {};
        }
    };
    DropdownSortComponent.prototype.changeSorting = function (id) {
        this.currentValue = id;
        this._sugarService.changeSorting(this.collection, id);
    };
    DropdownSortComponent.prototype.onMouseenterDropdown = function () {
        this.preventDropdownClose();
        if (!this.options.clickOpen) {
            if (!this._rendererHelper.hasClass(this.root, 'show')) {
                this._rendererHelper.trigger(this.btn, 'click');
            }
        }
    };
    DropdownSortComponent.prototype.onMouseleaveDropdown = function () {
        this.closeDropdownIn(1000);
    };
    DropdownSortComponent.prototype.onMouseoverDropdown = function () {
        if (this.closeTimeout) {
            this.preventDropdownClose();
            this.closeDropdownIn(2000);
        }
    };
    DropdownSortComponent.prototype.onClickDropdown = function (evt) {
        if (evt && evt.target.hasAttribute('data-dropdown-item')) {
            evt.stopPropagation();
        }
        this.closeDropdownIn(1500);
    };
    DropdownSortComponent.prototype.closeDropdownIn = function (time) {
        var self = this;
        this.preventDropdownClose();
        this.closeTimeout = setTimeout(function () {
            self.closeDropdown();
        }, time || 1000);
    };
    DropdownSortComponent.prototype.preventDropdownClose = function () {
        clearTimeout(this.closeTimeout);
    };
    DropdownSortComponent.prototype.closeDropdown = function () {
        this.preventDropdownClose();
        this._rendererHelper.removeClass(this.root, 'show');
        this._rendererHelper.removeClass(this.menu, 'show');
        this._rendererHelper.trigger(this.btn, 'blur');
    };
    DropdownSortComponent.prototype.trackByFn = function (index, item) {
        return item.id;
    };
    DropdownSortComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [SugarService,
            UniversalRendererHelper,
            UrlService])
    ], DropdownSortComponent);
    return DropdownSortComponent;
}());
export { DropdownSortComponent };
